import styled from "styled-components";
import {
  Button,
  buttonThemes,
  colors,
  HelperText
} from "@streeteasy/design-system";
import { TextArea } from "@streeteasy/design-system/form/TextAreaField";

const { BRAND_DARK } = colors;

export const CancelButton = styled(Button)`
  background: none;
  border: none;
  color: ${BRAND_DARK};
  height: 100%;
  min-width: auto;
  padding: 0;
  text-transform: uppercase;
  &:hover,
  &:active {
    background-color: transparent;
  }
`;

export const Disclaimer = styled(HelperText)`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 16px;
  text-align: left;
`;

export const EditTextArea = styled(TextArea)`
  margin-top: 9px;
  resize: none;
`;

export const Form = styled.form`
  margin: 0;
`;

export const SaveButton = styled(Button).attrs({
  theme: buttonThemes.PRIMARY,
  type: "submit"
})`
  height: 32px;
  min-width: auto;
  width: 95px;
  margin: 8px 16px 8px 0;
`;
